import React from "react";
import styled from "styled-components";
import { style } from "./style";

const DEFAULT_SIZE = "8px";

const ProgressBarBackground = styled.div`
  width: 100%;
  min-width: 80px;
  height: ${DEFAULT_SIZE};
  border-radius: ${DEFAULT_SIZE};
  background: #ececec;
  overflow: hidden;
`;

export const ProgressBarMeter = styled.div<{ $percentage: number }>`
  background: ${style.colors.blue.primary};
  height: ${DEFAULT_SIZE};
  width: ${({ $percentage }): number => $percentage}%;
  transition: 0.3s linear;
`;

export type Props = {
  minValue?: number;
  maxValue?: number;
  valueNow: number;
  /** valueText: the descriptive, human readable text alternative of aria-valuenow */
  valueText: string;
  className?: string;
  label?: string;
};

export const ProgressBar: React.FC<Props> = ({ minValue = 0, maxValue = 100, valueNow, valueText, className, label }) => {
  const percentage = (valueNow / maxValue) * 100;
  return (
    <ProgressBarBackground className={className}>
      <ProgressBarMeter
        role="progressbar"
        aria-label={label || "Progress bar"}
        $percentage={percentage}
        aria-valuemin={minValue}
        aria-valuemax={maxValue}
        aria-valuenow={valueNow}
        aria-valuetext={valueText}
      />
    </ProgressBarBackground>
  );
};
